import { FormField } from "@babackapp/ui/components/form";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";
import FormPasswordInput from "@babackapp/react-hook-forms-components/form-password-input";
import { useFormContext } from "react-hook-form";
import useTranslation from "@babackapp/translations/use-translation";

export default function ExportServerForm() {
  const { control } = useFormContext();
  const t = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <FormField
        control={control}
        name="server.serverType"
        render={({ field }) => (
          <FormOptionsSelector
            label={t("settings.integrations.exports.addExport.serverType")}
            options={serverTypeOptions}
            {...field}
          />
        )}
      />

      <FormField
        control={control}
        name="server.host"
        render={({ field }) => (
          <FormInput
            label={t("settings.integrations.exports.addExport.host")}
            placeholder="ftp.example.com"
            {...field}
          />
        )}
      />

      <FormInputRow>
        <FormField
          control={control}
          name="server.user"
          render={({ field }) => (
            <FormInput
              label={t("settings.integrations.exports.addExport.user")}
              placeholder="myftpuser"
              {...field}
            />
          )}
        />

        <FormField
          control={control}
          name="server.password"
          render={({ field }) => (
            <FormPasswordInput
              label={t("settings.integrations.exports.addExport.password")}
              placeholder="*********"
              {...field}
            />
          )}
        />
      </FormInputRow>

      <FormField
        control={control}
        name="server.path"
        render={({ field }) => (
          <FormInput
            label={t("settings.integrations.exports.addExport.path")}
            placeholder="./OUT/Baback"
            {...field}
          />
        )}
      />
    </div>
  );
}

const serverTypeOptions = [
  { key: "ftp", label: "FTP" },
  { key: "sftp", label: "SFTP" },
];
